package org.catharsis.spendtel.feature.share

import org.catharsis.spendtel.feature.data.ExpenseReport
import org.catharsis.spendtel.feature.data.formatCurrency
import org.catharsis.spendtel.feature.data.formatStatementPeriodLabel
import org.catharsis.spendtel.feature.data.formatReportDate
import org.catharsis.spendtel.feature.legal.LegalConstants

fun ExpenseReport.shareTitle(): String {
    financialPersonality?.label?.let { return "$it — ${LegalConstants.PRODUCT_NAME}" }
    monthlyStory?.headline?.let { return it }
    return "My ${LegalConstants.PRODUCT_NAME} spending story"
}

fun ExpenseReport.canShareSummary(): Boolean {
    if (!isComplete) return false

    return financialPersonality != null ||
        monthlyStory != null ||
        equivalences.isNotEmpty() ||
        highlights.isNotEmpty() ||
        goalInsights.isNotEmpty() ||
        moneyLeaks != null
}

fun ExpenseReport.toShareSummary(): String = buildString {
    appendLine(shareTitle())
    appendLine()

    formatStatementPeriodLabel(summary?.periodStart, summary?.periodEnd)?.let {
        appendLine(it)
    } ?: appendLine(formatReportDate(createdAtMillis))

    financialGoalUsed?.takeIf { it.isNotBlank() }?.let {
        appendLine("Goal: $it")
    }

    appendLine()

    financialPersonality?.let { personality ->
        appendLine("Personality: ${personality.label}")
        if (personality.description.isNotBlank()) {
            appendLine(personality.description)
        }
        appendLine()
    }

    monthlyStory?.headline?.takeIf { it.isNotBlank() }?.let {
        appendLine(it)
    }
    monthlyStory?.observations?.firstOrNull()?.takeIf { it.isNotBlank() }?.let {
        appendLine(it)
        appendLine()
    }

    equivalences.firstOrNull()?.let { equivalence ->
        appendLine(
            "${equivalence.sourceLabel}: " +
                "${formatCurrency(equivalence.amount, dashboardCurrency())} " +
                equivalence.comparison,
        )
        if (equivalence.insight.isNotBlank()) {
            appendLine(equivalence.insight)
        }
        appendLine()
    }

    highlights.firstOrNull()?.takeIf { it.isNotBlank() }?.let {
        appendLine(it)
        appendLine()
    }

    goalInsights.firstOrNull()?.let { insight ->
        appendLine(insight.insight)
        if (insight.suggestion.isNotBlank()) {
            appendLine(insight.suggestion)
        }
        appendLine()
    }

    moneyLeaks?.subscriptions?.firstOrNull()?.let { subscription ->
        appendLine(
            "Money leak: ${subscription.name} — " +
                "${formatCurrency(subscription.amount, dashboardCurrency())}/mo",
        )
        appendLine()
    }

    append("Generated with ${LegalConstants.PRODUCT_NAME} · ${LegalConstants.WEBSITE}")
}
